// once we work on the functionality, the selectors will be created here
// sample code

import { createSelector } from 'reselect';
import { initState } from './reducer';
import { welcomeInitState } from '../salesforce-landing/reducer';

const companyInfoReducer = (state) => state.companyinfo || initState;
const WelcomePage = (state) => state.WelcomePage || welcomeInitState;

const companyInfoData = createSelector(companyInfoReducer, (cnter) => cnter.companyInfoData.company);
const isCompanyLoading = createSelector(companyInfoReducer, (cnter) => cnter.isCompanyLoading);
const savingCompanyInfoData = createSelector(companyInfoReducer, (cnter) => cnter.savingCompanyInfoData);
const savingStatus = createSelector(companyInfoReducer, (cnter) => cnter.savingStatus);
const opportunityData = createSelector(WelcomePage, (cnter) => cnter.opportunityData);

export default {
	companyInfoData,
	companyInfoReducer,
	isCompanyLoading,
	savingCompanyInfoData,
	savingStatus,
	opportunityData,
};
